<template>
  <div class="frisbuy-sr-story" @click="$emit('click', story, $event)">
    <div
      :class="{
        'frisbuy-sr-story-wrapper': true,
        'frisbuy-story-square': isSquare,
        'frisbuy-story-vertical-rectangle': isVerticalRectangle,
        'frisbuy-sr-visited': hasVisited(story),
        'frisbuy-sr-selected':
          selectedStory &&
          story.instagramPost.frisbuyId ==
            selectedStory.instagramPost.frisbuyId,
      }"
      :style="{
        background: !hasVisited(story) && settings.widget.borderColor,
      }"
    >
      <div
        class="frisbuy-sr-story-image"
        :style="{
          'background-image': backgroundImage,
        }"
        :data-src="getMainImage(story)"
        ref="story"
      >
        <img
          ref="image"
          :src="getMainImage(story)"
          @error="(e) => errorImageHandler(e)"
        />
        <!-- <img :src="getMainImage(story, true)"/>
              <video v-if="story.media[0].videoUrl"><source :src="story.media[0].videoUrl" type="video/mp4"></video> -->
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.frisbuy-sr-widget .frisbuy-sr-story-wrapper {
  background: radial-gradient(
    circle at 30% 107%,
    #fdf497 0%,
    #fdf497 5%,
    #fd5949 45%,
    #d6249f 60%,
    #285aeb 90%
  );
  border-radius: 50%;
  padding: 2px;
  flex-shrink: 0;
  cursor: pointer;

  /* Custom size section - start */

  // Rectangle 767-
  &.frisbuy-story-vertical-rectangle {
    width: calc(
      var(--frisbuy-mobile-size) + var(--frisbuy-story-wrapper-padding) * 2
    );
    height: calc(
      var(--frisbuy-mobile-size) + var(--frisbuy-story-wrapper-padding) * 2
    );
  }

  // Circle/square 767+
  width: calc(
    var(--frisbuy-desktop-size) + var(--frisbuy-story-wrapper-padding) * 2
  );
  height: calc(
    var(--frisbuy-desktop-size) + var(--frisbuy-story-wrapper-padding) * 2
  );

  // Circle/square light 767+
  &:after {
    width: calc(
      var(--frisbuy-desktop-size) + var(--frisbuy-story-wrapper-padding) * 2
    );
    height: calc(
      var(--frisbuy-desktop-size) + var(--frisbuy-story-wrapper-padding) * 2
    );
  }

  @media screen and (max-width: 767px) {
    // Circle/square 767-
    width: calc(
      var(--frisbuy-mobile-size) + var(--frisbuy-story-wrapper-padding) * 2
    );
    height: calc(
      var(--frisbuy-mobile-size) + var(--frisbuy-story-wrapper-padding) * 2
    );

    // Circle/square light 767-
    &:after {
      width: calc(
        var(--frisbuy-mobile-size) + var(--frisbuy-story-wrapper-padding) * 2
      );
      height: calc(
        var(--frisbuy-mobile-size) + var(--frisbuy-story-wrapper-padding) * 2
      );
    }
  }

  // Circle/square light 768+
  @media screen and (min-width: 768px) {
    &.frisbuy-story-vertical-rectangle {
      width: calc(
        var(--frisbuy-desktop-size) + var(--frisbuy-story-wrapper-padding) * 2
      );
      height: var(--frisbuy-rectangle-size);
    }
  }

  /* Custom size section - end */

  &.frisbuy-story-square {
    border-radius: inherit;

    & > div {
      border-radius: inherit;
    }
  }

  &.frisbuy-story-vertical-rectangle {
    @media screen and (min-width: 768px) {
      border-radius: 5%;

      .frisbuy-sr-story-image {
        border-radius: 4%;
      }
    }

    &:after {
      display: none;
    }
  }

  &:hover {
    opacity: 0.8;
  }

  &.frisbuy-sr-visited {
    background: transparent !important;
  }

  &.frisbuy-sr-selected {
    position: relative;

    &:before {
      content: "";
      position: absolute;
      display: block;
      border-width: 5px 0 5px 5px;
      border-style: solid;
      border-color: transparent transparent transparent #222222;
      left: 100%;
      top: calc(50% - 5px);
    }
  }

  .frisbuy-sr-story-image {
    width: 100%;
    height: 100%;
    background-color: #fff;
    border-radius: 50%;
    padding: 2px;
    background-size: cover;
    background-position: center;
    border: 2px solid #fff;
    overflow: hidden;

    img,
    video {
      opacity: 0;
      pointer-events: none;
    }
  }
}
</style>

<script>
import { errorImageHandler } from "@/api/errorHandlers";
import STORIES_CONSTS from "@/common/consts/stories.js";

export default {
  inject: ["settings", "isMobileLandscape"],

  data() {
    return {
      previewImg: undefined,
    };
  },

  emits: ["click"],

  props: {
    story: { type: Object, required: true },
    selectedStory: { type: Object, required: false },
    visited: { type: Array, required: false, default: () => [] },
  },
  created() {
    this.previewImg = this.getMainImage(this.story);
  },

  methods: {
    hasVisited(story) {
      const { frisbuyId } = story.instagramPost;
      return this.visited.includes(frisbuyId);
    },

    getMainImage(story, highResolution) {
      return highResolution
        ? story.media[0].imageUrl
        : story.media[0].thumbnailUrl;
    },

    errorImageHandler(e) {
      errorImageHandler(
        { e, errorIndex: this.errorIndex, maxCountOfTryingForSource: 2 },
        (recoveryURL) => {
          this.$refs.image.src = recoveryURL;
          this.errorIndex += 1;
        },
        () => {
          this.errorIndex = 0;
        }
      );
    },
  },

  computed: {
    backgroundImage() {
      return `url(${this.previewImg}) ${
        this.story.media[0].background
          ? "," + this.story.media[0].background
          : ""
      }`;
    },

    isInline() {
      const { widget } = this.settings;

      return widget && (widget.inlineDesktop == "1" || this.isMobileLandscape);
    },

    isSquare() {
      if (!this.isInline) return false;

      return this.settings.widget.shape === STORIES_CONSTS.SHAPE_TYPES.SQUARE;
    },

    isVerticalRectangle() {
      return (
        this.isInline &&
        this.settings.widget.shape ===
          STORIES_CONSTS.SHAPE_TYPES.VERTICAL_RECTANGLE
      );
    },
  },
};
</script>
